import React from 'react';
import PropTypes from 'prop-types';

class BeforeAfterSets extends React.Component {
    static propTypes = {
        beforeAfterSets: PropTypes.arrayOf(PropTypes.shape({
            before_photo: PropTypes.string.isRequired,
            after_photo: PropTypes.string.isRequired,
        })).isRequired
    };

    componentDidMount() {
        this.initSwiper();
    }

    componentWillUnmount() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }

    initSwiper = () => {
        if (typeof Swiper !== 'undefined') {
            this.swiper = new Swiper('.before-after-swiper-container', {
                grabCursor: true,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
        }
    };

    render() {
        return (
            <div className="before-after-container">
                <div className="header">
                    {i18n.t('company-profile.previous-cleanings')}
                </div>

                <div className="swiper-container before-after-swiper-container">
                    <div className="swiper-wrapper">
                        {this.props.beforeAfterSets.map((beforeAfterSet, index) => (
                            <div className="swiper-slide" key={index}>
                                <div className="before-after-slide-content">
                                    <div className="before-after-photo-slide">
                                        <img src={beforeAfterSet.before_photo}
                                             loading="lazy"
                                             decoding="async"
                                             fetchpriority="low"
                                             className="photo-image"
                                             alt={`${i18n.t('company-profile.before')} photo`} />
                                        <div className="photo-overlay">
                                            <div className="photo-label">{i18n.t('company-profile.before')}</div>
                                        </div>
                                    </div>

                                    <div className="before-after-photo-slide">
                                        <img src={beforeAfterSet.after_photo}
                                             loading="lazy"
                                             decoding="async"
                                             fetchpriority="low"
                                             className="photo-image"
                                             alt={`${i18n.t('company-profile.after')} photo`} />
                                        <div className="photo-overlay">
                                            <div className="photo-label">{i18n.t('company-profile.after')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="swiper-pagination"></div>

                    <div className="swiper-button-prev visible-md visible-lg"></div>
                    <div className="swiper-button-next visible-md visible-lg"></div>
                </div>
            </div>
        );
    }
}

export default BeforeAfterSets;
